export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-background-100 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20modern%20UI%20design%2C%20news%20feed%20layout%2C%20editorial%20style%2C%20soft%20lighting%2C%20product%20showcase&width=600&height=800&seq=app-mockup-1&orientation=portrait"
                alt="今日大瓜移动端页面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              随时随地吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              今日大瓜移动端适配已全面优化，在手机上即可流畅浏览全部吃瓜资讯。支持浏览器收藏到桌面，一键直达吃瓜现场，让你通勤、排队、摸鱼时都能畅快吃瓜。
            </p>
            <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-smartphone-line"></i>
              <span>添加到手机桌面</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}